module.exports = __webpack_public_path__ + "img/esan.68578156.jpeg";